import { DropdownWithRemoteSearch, Loader } from "uikit"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import { Button, Container, Grid } from "semantic-ui-react"
import { useStore } from "store"
import "./Overview.css"

const FindYourEmployer = props => {
  const [employerNotFound, setEmployerNotFound] = useState(null)
  const [employerIsCustomer, setEmployerIsCustomer] = useState(false)
  const [nextUrl, setNextUrl] = useState(props.nextUrl)
  const [isPending, setIsPending] = useState(false)
  const [employerId, setEmployerId] = useState("")
  const [employer, setEmployer] = useState(null)

  const { searchForEmployerCustomers, getEmployerCustomer } = useStore()

  return (
    <Container textAlign="center" className="white">
      <Grid stackable className="overview_maindiv">
        <Grid.Row style={{ paddingBottom: "0px" }}>
          <Grid.Column textAlign="center">
            <h2 className="overview__Heading">Find Your Employer</h2>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered style={{ paddingTop: "0px" }}>
          <Grid.Column
            className="overview__Description"
            width={14}
            textAlign="center"
          >
            <p className="overview__DescriptionText">
              Let's check if SAVVI is available through your employer. You can
              sign-up on your own if your employer doesn't offer SAVVI.
            </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered columns={"equal"} style={{ marginTop: "2em" }}>
          <Grid.Column width={"6"}>
            <DropdownWithRemoteSearch
              value={employerId}
              fluid
              options={[]}
              placeholder="Employer"
              search
              selection
              remoteSearch={async query => {
                const {
                  employers: searchResults
                } = await searchForEmployerCustomers(query)
                if (searchResults.length === 0) {
                  setEmployerNotFound(true)
                  return []
                }
                setEmployerNotFound(false)
                return searchResults.map(el => ({
                  text: el.name,
                  value: el.id
                }))
              }}
              onChange={async (_, { value }) => {
                setIsPending(true)
                const employerCustomer = await getEmployerCustomer(value)
                const { employer } = employerCustomer

                setNextUrl(
                  employer.is_customer ? employer.enrollment_url : props.nextUrl
                )
                setEmployerId(value)
                setEmployerIsCustomer(employer.is_customer)
                setEmployer(employer)
                setIsPending(false)
              }}
            />
            <Loader text={"Checking..."} active={isPending} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered style={{ paddingBottom: "0" }}>
          <Grid.Column width={12} textAlign="center">
            {employer ? (
              <p style={{ marginTop: "1em", textAlign: "center" }}>
                <b>{employer.name}</b>
                <br />
                {employer.description}
              </p>
            ) : null}

            {employerNotFound ? (
              <p>
                SAVVI is <b>not available</b> through this employer at this
                time. If you have a spouse or partner, maybe try their employer?
              </p>
            ) : null}
            {employer && !employer.is_customer ? (
              <p>
                SAVVI is <b>not available</b> through {employer.name} at this
                time. If you have a spouse or partner, maybe try their employer?
              </p>
            ) : null}
            {employer && employer.is_customer ? (
              employer.is_sponsored ? (
                <p>
                  Yay! SAVVI <b>is available</b> through {employer.name}{" "}
                  <b>at NO COST</b> to you!
                </p>
              ) : (
                <p>
                  Yay! SAVVI <b>is available</b> through {employer.name} as a
                  <i>voluntary benefit</i>.
                </p>
              )
            ) : null}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered columns="equal" style={{ marginTop: "2em" }}>
          <Grid.Column textAlign="center">
            {!(employer && employer.is_customer) ? (
              <p>
                Your employer doesn't offer SAVVI? Get started for <b>free</b>
                <br />
                or <i>choose a paid plan</i>.
              </p>
            ) : null}
            <p>
              {nextUrl.startsWith("http") ? (
                <a href={nextUrl}>
                  <Button
                    primary
                    size="big"
                    className="overview_Button"
                    data-testid="continue"
                  >
                    {employerIsCustomer ? "Enroll" : "Select Plan"}
                  </Button>
                </a>
              ) : (
                <Link to={nextUrl} className="navlink">
                  <Button
                    primary
                    size="big"
                    className="overview_Button"
                    data-testid="continue"
                  >
                    {employerIsCustomer ? "Enroll" : "Select Plan"}
                  </Button>
                </Link>
              )}
            </p>
            <div style={{ marginTop: "4rem", marginBottom: "-2rem" }}>
              <Link to="/signup/invited" data-testid="invited">
                Have an invite?
              </Link>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  )
}

export default FindYourEmployer
